import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Table } from "react-bootstrap";
import Crypt from '../lib/Crypt';
import swal from 'sweetalert';
import C from '../lib/Config';

const DosageLevelArr = [
    { key: Crypt.getUniqueKey('0'), id: '0', label: '0' },
    { key: Crypt.getUniqueKey('1'), id: '-1', label: '-1' },
    { key: Crypt.getUniqueKey('2'), id: '-2', label: '-2' },
    { key: Crypt.getUniqueKey('3'), id: '-3', label: '-3' },
    { key: Crypt.getUniqueKey('4'), id: '-4', label: '-4' },
]
export default class ProtocolDosagePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dosageLevel: '',
            dosageValue: '',
            dosageQty: '',
            dosageUnitValue: '',
            //dosageUnit: [],
            dosageUnitArr: [],
            chemoMedicineDId: 0, 
            chemoMedicineDosageListArr: [],
            chemoMedicineDosageId: '',
            chemoMedicineDosageValue: ''
        }; 
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.getAllUnits();  
    }
    handleChange(event){
        if(event.target.name === 'dosageLevel'){
            this.setState({dosageLevel: event.target.value});
            this.setState({dosageValue: event.target.options[event.target.selectedIndex].text});
        }
        if(event.target.name === 'dosageQty'){
            this.setState({dosageQty: event.target.value});
        }
        if(event.target.name === 'dosageUnit'){
            this.setState({dosageUnit: event.target.value});
            this.setState({dosageUnitValue: event.target.options[event.target.selectedIndex].text});
        } 
        if(event.target.name === 'chemoMedicine'){
            this.setState({chemoMedicineDosageId: event.target.value});
            this.setState({chemoMedicineDosageValue: event.target.options[event.target.selectedIndex].text});
        }
    }
    // validateDosage(){
    //     let formIsValid = true;
    //     let errors = {};
    //     if (this.state.dosageLevel === "" || this.state.dosageLevel === null) {
    //         errors["dosageLevel"] = "Please enter first name";
    //         formIsValid = false;
    //     }
    //     if (this.state.dosageQty === "" || this.state.dosageQty === null) {
    //         errors["dosageQty"] = "Please select schedule for doctor visit";
    //         formIsValid = false;
    //     }
    //     if (this.state.dosageUnit === "" || this.state.dosageUnit === null) {
    //         errors["dosageUnit"] = "Please select schedule for doctor visit";
    //         formIsValid = false;
    //     } 
    //     this.setState({protocol: errors });
    //     return formIsValid;
    // }
    getAllUnits() {
        return fetch(C.getUrl() + '/unitMst/getAllUnits')
            .then(res => res.json())
            .then(res => {
                if (!Array.isArray(res)) return;
                var wt = [];
                res.forEach((item) => {
                    wt.push({ id: item.unitId, name: item.unitName });
                });
                this.setState({ dosageUnitArr: wt });
            })
            .catch(err => {
                console.error("Error fetching units: " + err);
            });
    }
    savProtocolDosage(event){
        let data = { 
            dosageLevels: this.state.dosageLevel,
            dosageValues: this.state.dosageValue,
            dosageUnits: this.state.dosageUnit,
            dosageUnitValues: this.state.dosageUnitValue ,
            dosageQtys: this.state.dosageQty,

            chemoMedicineDosageID: this.state.chemoMedicineDosageId,
            chemoMedicineDosageValue: this.state.chemoMedicineDosageValue,
            chemoMedicineDId: this.state.chemoMedicineDId
        }
        this.props.saveProtocolDosageTable(data); 
    }
    getProtocolDosageDetail(chemoDoseageList) {
        console.log("medicineArraaaaa : " + JSON.stringify(chemoDoseageList));
        this.setState({ chemoMedicineDosageListArr: chemoDoseageList });  
    }
    render() {
        const { showProtocolDosagePopup, closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        const { dosageUnitArr, chemoMedicineDosageListArr } = this.state;
        return (
            <div>
                <Modal id="report" show={showProtocolDosagePopup} centered animation={true} scrollable={true} size="md">
                    <Modal.Header closeButton onClick={() => closePreviewModal()}>
                        <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">Protocol Dosage</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col lg='12'>
                                    <Form.Group>
                                        <Form.Label>Chemo Medicine</Form.Label>
                                        <Form.Control as="select" id="" name='chemoMedicine' value={this.state.chemoMedicineDosageId} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Chemo Medicine -</option> 
                                                { 
                                                    chemoMedicineDosageListArr.map((item, i) => {
                                                        return (
                                                            <option key={item.chemoMedicineId} value={item.chemoMedicineId}>{`${item.chemoMedicineName}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                        {/* <div className="invalid-feedback">{this.state.protocol["dosageMethod"]}</div> */}
                                    </Form.Group>
                                </Col> 
                                <Col lg="12">
                                    <Form.Group>
                                        <Form.Label>Dosage Level</Form.Label>
                                        <Form.Control as="select" id="" name='dosageLevel' value={this.state.dosageLevel} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Dosage Level -</option>
                                            {
                                                DosageLevelArr.map((item, i) => {
                                                        return (
                                                            <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                    </Form.Group>
                                    {/* <div className="invalid-feedback">{this.state.protocol["chemoMedicine"]}</div> */}
                                </Col>
                                <Col lg='12'>
                                    <Form.Group>
                                        <Form.Label>Dosage Quantity <span style={{ verticalAlign: "text-bottom", fontSize: "10px" }} className="text-red">(For terminal dosage type "No Dosage")</span></Form.Label>
                                        <Form.Control type='text' placeholder='' name='dosageQty' onChange={this.handleChange} />
                                        {/* <div className="invalid-feedback">{this.state.protocol["dosageMethod"]}</div> */}
                                    </Form.Group>
                                </Col>
                                <Col lg="12">
                                    <Form.Group>
                                        <Form.Label>Unit</Form.Label>
                                        <Form.Control as="select" id="" name='dosageUnit' value={this.state.dosageUnit} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Unit -</option>
                                            {
                                                dosageUnitArr.map((item, i) => {
                                                        return (
                                                            <option key={item.id} value={item.id}>{`${item.name}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                    </Form.Group>
                                    {/* <div className="invalid-feedback">{this.state.protocol["chemoMedicine"]}</div> */}
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='text-center'>
                        <Button className="btn btn-secondary" onClick={this.savProtocolDosage.bind(this)}>
                            {this.state.saveLoader && (
                                <Spinner className='mr-2' animation='border' size='1.5rem' />
                            )}
                            Add 
                        </Button>
                        <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}